"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emrParsedDataMapper = emrParsedDataMapper;
function emrInfoMapper(info) {
    return {
        physician: info.physician.map(physician => {
            var _a;
            return (Object.assign(Object.assign({}, physician), { name: (_a = physician.name) !== null && _a !== void 0 ? _a : "", phoneNo: physician.phoneNo ? physician.phoneNo.replace(/-/g, "") : "" }));
        }),
        pharmacy: info.pharmacy.map(pharmacy => {
            var _a;
            return (Object.assign(Object.assign({}, pharmacy), { name: (_a = pharmacy.name) !== null && _a !== void 0 ? _a : "", phoneNo: pharmacy.phoneNo ? pharmacy.phoneNo.replace(/-/g, "") : "" }));
        }),
        careGiver: info.careGiver.map(careGiver => {
            var _a;
            return (Object.assign(Object.assign({}, careGiver), { name: (_a = careGiver.name) !== null && _a !== void 0 ? _a : "", phoneNo: careGiver.phoneNo ? careGiver.phoneNo.replace(/-/g, "") : "" }));
        }),
    };
}
function emrParsedDataMapper(emrParsedData) {
    var _a, _b, _c, _d;
    if (emrParsedData.isDataParsed && emrParsedData.parseData) {
        const { parseData } = emrParsedData;
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ((parseData === null || parseData === void 0 ? void 0 : parseData.mrn) && { mrn: parseData.mrn })), (((_a = parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo) === null || _a === void 0 ? void 0 : _a.firstName) && {
            name: `${(parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.firstName) || ""} ${(parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.lastName) || ""}`.trim(),
        })), ((parseData === null || parseData === void 0 ? void 0 : parseData.insurance) && { insurance: parseData.insurance })), ((parseData === null || parseData === void 0 ? void 0 : parseData.about) && { about: parseData.about })), (((_b = parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo) === null || _b === void 0 ? void 0 : _b.email) && {
            email: {
                email: (_c = parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo) === null || _c === void 0 ? void 0 : _c.email,
                enabled: false,
            },
        })), ((parseData === null || parseData === void 0 ? void 0 : parseData.info) && { info: emrInfoMapper(parseData.info) })), ((parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo) && {
            patientInfo: {
                firstName: parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.firstName,
                lastName: parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.lastName,
                dob: parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.dob,
                phoneNo: (_d = parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.phoneNo) === null || _d === void 0 ? void 0 : _d.replace(/-/g, ""),
                countryCode: (parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.countryCode) || "+1",
                name: `${(parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.firstName) || ""} ${(parseData === null || parseData === void 0 ? void 0 : parseData.patientInfo.lastName) || ""}`.trim(),
                address: {
                    geoLocation: {
                        coordinates: [0, 0],
                        type: "",
                    },
                    lat: 0,
                    lng: 0,
                    placeName: parseData.patientInfo.address.placeName,
                },
            },
        }));
    }
    else {
        throw new Error("EMR data could not be parsed");
    }
}
